import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Chaufa from "../../../images/modulo14/chaufa.png";
import Lampa from "../../../images/modulo14/lampa.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad5.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[6];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[7].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[7].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[5].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[5].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Todas las lenguas van cambiando con el paso del tiempo y por el
              contacto que tienen con otras lenguas. Lee los siguientes textos
              al respecto:
            </li>
          </ul>
        </div>
        <div className="col-12">
          <div className="row align-items-center my-5 px-4">
            <div className="col-md-6">
              <div className="p-4">
                <p className="fs-5">
                  Cuando mis antepasados llegaron al Perú, poco a poco fueron
                  aprendiendo el castellano. Pero siguieron usando algunas
                  palabras en chino, por ejemplo, la palabra “kion”. En el resto
                  del mundo que habla castellano, el kion es conocido como
                  jengibre, pero en el Perú preferimos usar esta palabra de
                  origen chino.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <img src={Chaufa} className="bg-white img-fluid" alt="Chaufa" />
            </div>
          </div>
          <div className="row align-items-center my-5 px-4">
            <div className="col-md-6">
              <img src={Lampa} className="bg-white img-fluid" alt="Lampa" />
            </div>
            <div className="col-md-6">
              <div className="p-4">
                <p className="fs-5">
                  Esto es una lampa y se usa en la agricultura, en la
                  construcción, en la jardinería. “Lampa” es una palabra aimara.
                  La mayoría de gente que habla castellano fuera del Perú la
                  conoce como “pala”.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Ahora conversa con un compañero, compañera o familiar sobre lo
              siguiente:
            </li>
          </ul>
          <div className="">
            <p>
              ¿Se puede decir que “kion” y “lampa” son palabras del castellano
              peruano? ¿Por qué?
            </p>
            <textarea className="form-control mb-4" rows={3} />

            <p>
              Piensa en una palabra que se usa en castellano pero que proviene
              de otro idioma y escríbela acá.{" "}
            </p>
            <textarea className="form-control mb-4" rows={3} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que, cuando dos lenguas conviven en un mismo territorio,
            terminan, de alguna manera, dialogando y, por ello, intercambian
            ideas, conceptos, palabras. En las actividades siguientes, se busca
            que dialoguen acerca de palabras que usamos en el castellano y que
            provienen de otras lenguas.
          </li>
          <li>
            Pida que observen las dos imágenes y las describan. Lea la primera
            indicación: Todas las lenguas van cambiando con el paso del tiempo y
            por el contacto que tienen con otras lenguas. Lee los siguientes
            textos al respecto. Pida a la niña o al niño que lean en voz alta
            los textos que se presentan. Después de la lectura, elabore algunas
            preguntas sobre el texto leído:
            <ul>
              <li>
                <i>
                  “¿A qué se refiere la palabra “antepasados”? ¿De dónde
                  provienen sus antepasados? ¿Conoces alguna comida preparada
                  con kion? ¿Cuál?”.
                </i>
              </li>
              <li>
                <i>
                  “¿Para qué se puede usar una lampa? ¿Han usado alguna vez una
                  lampa? ¿Para qué la usaron?”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Ahora conversa con un compañero,
            compañera o familiar sobre lo siguiente:{" "}
            <i>
              ¿Se puede decir que “kion” y “lampa” son palabras del castellano
              peruano? ¿Por qué? - Piensen en una palabra que se usa en
              castellano pero que proviene de otro idioma y compártanla con el
              resto de la clase.
            </i>
          </li>
          <li>
            Déles tiempo para que dialoguen. Pida algunas de las respuestas a
            las que han llegado. Retómelas y coméntelas. Puede, por ejemplo,
            mencionar lo siguiente:
            <ul>
              <li>
                <i>
                  “Sí, se puede decir que “kion” y “lampa” son palabras del
                  castellano peruano, a pesar de que tienen su origen en otro
                  idioma. “Kion” es una palabra china y “lampa” una palabra
                  aimara. Son palabras que se incorporaron al castellano en el
                  Perú gracias a los inmigrantes chinos y a la población
                  originaria aimara”.
                </i>
              </li>
              <li>
                <i>
                  “Sobre palabras que se usan en castellano pero que provienen
                  de otro idioma tenemos ejemplos como “palta”, que es una
                  palabra quechua y “choclo”, también quechua”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
